import { PreAuth } from '@/components/PreAuth/PreAuth';
import { Alert, Box, Button, TextInput } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/AuthProvider';
import { IconLock } from '@tabler/icons-react';
import {useEffect, useState} from 'react';
import api from '@/api/api';
import { isEmpty } from '@/utils/functions';

export const ForgotPasswordPage = (): JSX.Element => {
  const navigate = useNavigate();
  const { token } = useAuth();

  useEffect(() => {
    if (token) {
      navigate('/my-account');
    }
  }, [token, navigate]);


  const icon = <IconLock />;

  // use variables to implement resend feature
  const [submitButtonText, setSubmitButtonText] = useState('Odeslat');
  const [descriptionEmail, setDescriptionEmail] = useState('');
  const [countdown, setCountdown] = useState(0);
  const [formData, setFormData] = useState({ email: '' });
  const [emailError, setEmailError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleStorno = () => {
    // simply go back to login page
    setEmailError('');
    navigate('login');
  };

  const handleChange = (event: any) => {
    const { name, value } = event.target;
    setFormData(prevState => ({ ...prevState, [name]: value }));
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    // to prevent refresh
    event.preventDefault();

    setEmailError('');

    if (isEmpty(formData.email)) {
      setEmailError('Toto je povinný atribut!');
      return;
    }

    const emailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
    if (!emailRegex.test(formData.email)) {
      setEmailError('Nespravný format emailové adresy');
      return;
    }

    setLoading(true);

    try {
      const response = await api.post('/auth/password-reset', formData);
      if (response.status === 202) {
        setDescriptionEmail('Pokud email existuje, byl odeslán odkaz na jeho obnovu.');
      } else {
        setEmailError('Neočekávaná odpověď serveru.');
      }


    // tip for user
    setDescriptionEmail('Odkaz nepřišel? Počkejte a zkuste ještě jednou!');

    // countdown: 60 sec and then allow resend
    setCountdown(60);
    const timer = setInterval(() => {
      setCountdown(prevCountdown => {
        if (prevCountdown === 1) {
          clearInterval(timer);
          // update button text
          setSubmitButtonText('Odeslat znovu');
          return 0;
        }
        // update button text with new countdown value
        setSubmitButtonText(`Odeslat znovu (${prevCountdown - 1} s)`);
        return prevCountdown - 1;
      });
    }, 1000);
    } catch (error: any) {
      setEmailError(
       'Nastala chyba na serveru. Zkuste to prosím později.'
      );
    } finally {
      setLoading(false);
    }
    
  };

  return (
    <PreAuth>
      <Box className="flex flex-col justify-center items-center w-full pt-12 pb-24">
        <Alert
          maw="30rem"
          variant="transparent"
          color="blue"
          title="Zapomenuté heslo"
          icon={icon}
          className="w-full"
          radius="md"
        >
          Po odesílání na Váš E-mail přijde odkaz na změnu hesla.
        </Alert>
        <form
          onSubmit={handleSubmit}
          className="flex flex-col justify-center items-center w-full gap-4"
        >
          <TextInput
            // name attribute must be the same as corresponding key in form
            name="email"
            inputWrapperOrder={['label', 'input', 'description', 'error']}
            onChange={handleChange}
            description={descriptionEmail}
            radius="md"
            size="md"
            variant="filled"
            maw="25rem"
            placeholder="E-mail"
            className="w-full"
            error={emailError}
          />
          <Button
            maw="25rem"
            size="md"
            type="submit"
            loading={loading}
            // block the button if the timer is still going
            disabled={loading || countdown !== 0}
            className="w-full rounded-lg text-lg"
          >
            {submitButtonText}
          </Button>
        </form>
        <Button
          variant="outline"
          maw="25rem"
          size="md"
          className="w-full rounded-lg text-lg mt-4"
          onClick={handleStorno}
        >
          Storno
        </Button>
      </Box>
    </PreAuth>
  );
};
